import { Layout } from '@components/Layout';
import PermissionGate from '@components/upercut-permissions/PermissionGate';
import { Route, Routes } from 'react-router-dom';
import ScoringDashboardModule from '@modules/scoring/ScoringDashboardModule';
import ScoringBatchDetailModule from '@modules/scoring/ScoringBatchDetailModule';

const ScoringPage = () => {
    return (
        <Layout
            breadcrumbs={[
                { label: 'Tableau de bord', href: '/', value: 'dashboard' },
                { label: 'Scoring', href: '/scoring', value: 'scoring' },
            ]}
            heading="Scoring"
        >
            <Routes>
                <Route
                    path="/"
                    element={
                        <PermissionGate permission="scoring:read">
                            <ScoringDashboardModule />
                        </PermissionGate>
                    }
                />
                <Route
                    path="/batch/:batchId"
                    element={
                        <PermissionGate permission="scoring:read">
                            <ScoringBatchDetailModule />
                        </PermissionGate>
                    }
                />
            </Routes>
        </Layout>
    );
};

export default ScoringPage;
